import ItemDepositAndWithdraw from './item-deposit-and-withdraw'

const WalletTable = ({ title, descriptionNoItms, deposits }) => {
  return (
    <div className='bg-[#151617] rounded-xl flex flex-1 flex-col gap-4 p-2 sm:p-8'>
      <h1 className="text-[#77ed91] text-2xl font-semibold tracking-wide">{title}</h1>
      <div>
        <div className="flex items-center gap-4 justify-between bg-[#212325] rounded-t-xl m-0 p-2 sm:p-4">
          <p className='w-[33%] text-center'>Date</p>
          <p className='w-[25%] text-center'>Amount</p>
          <p className='w-[25%] text-center'>status</p>
          <p className='w-[50px] hidden sm:inline-block'></p>
        </div>
        {deposits?.length === 0 && (
          <div className="flex items-center justify-center w-full h-[20rem]">
            <p className="text-[#909093] text-base text-center">
                {descriptionNoItms}
            </p>
          </div>
        )}
        <div className='flex flex-col gap-2 mt-4'>
          {deposits.map((deposit) => {
            return <ItemDepositAndWithdraw item={deposit} />;
          })} 
        </div>
      </div>
    </div>
  );
};

export default WalletTable